import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { useForm } from "react-hook-form";
import moment from "moment";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function JobCategory(props) {
  const [categories, setCategories] = useState([]);
  const user = useSelector((state) => state.User);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  // Toggle modal
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  // console.log("user", user);

  // get enquiries
  const getCategories = () => {
    setIsLoading(true);
    apiReq(url.GET_JOB_CATEGORY, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setCategories(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getCategories();
  }, []);

  // TODO: columns
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          <button
            className="btn btn-success btn-sm mr-2"
            onClick={() => handleEdit(record)}
          >
            <i className="ri-pencil-line"></i>
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(record._id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_JOB_CATEGORY + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire({
                title: "Deleted!",
                text: res.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              getCategories();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (selectedItem === null) {
      setIsLoading(true);
      apiReq(
        url.CREATE_JOB_CATEGORY,
        {
          title: data.title,
          description: data.description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getCategories();
            setIsOpenModal(false);
            setSelectedItem(null);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_JOB_CATEGORY + selectedItem._id,
        {
          title: data.title,
          description: data.description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getCategories();
            setSelectedItem(null);
            setIsOpenModal(false);
            reset();
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Handle edit category
  const handleEdit = (item) => {
    setSelectedItem(item);
    setValue("title", item.title);
    setValue("description", item.description);
    setIsOpenModal(true);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Modal toggle={toggleModal} isOpen={isOpenModal} size="lg">
          <ModalHeader>
            {selectedItem !== null ? "Update category" : "Create new category"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("title", { required: true })}
                />
                {errors.title && (
                  <span className="text-danger">Title is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Description</label>
                <textarea
                  className="form-control"
                  {...register("description", { required: true })}
                />
                {errors.description && (
                  <span className="text-danger">Description is required</span>
                )}
              </div>
              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggleModal}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Job Category</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => setIsOpenModal(!isOpenModal)}
                    >
                      Create new category
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <Table
                columns={columns}
                dataSource={categories}
                bordered
                loading={isLoading}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default JobCategory;
